<template>
	<div id="home" :class="$vuetify.breakpoint.xs ? 'px-2 pb-2': 'px-6'">
		<template>
			<div class="top-button mt-1">
				<v-btn class="text-capitalize px-3" :color="'#FAFAFA'" @click="show_edit = true">
					Customise
				</v-btn>
			</div>
			<ProgressDoubleLinear v-if="loading" class="mt-5"/>
			<v-row v-if="$vuetify.breakpoint.name !== 'xs' && widgets && !loading">
				<v-row v-if="widgets.jobsyoumanage.visible" class="my-5" style="width: 100%">
					<div class="px-6" style="width: 100%">
						<DashboardItem
							:title="widgets.jobsyoumanage.title"
							@dashboardItemClose="onDashboardItemClose(widgets.jobsyoumanage)"
						/>
						<JobsYouManage class="dashboard-item dashboard-item-special" @add-timesheet="onAddTimesheet"/>
					</div>
				</v-row>
				<v-row v-if="widgets.mytasks.visible" class="my-3" style="width: 100%">
					<div class="px-6" style="width: 100%">
						<DashboardItem
							:title="widgets.mytasks.title"
							@dashboardItemClose="onDashboardItemClose(widgets.mytasks)"
						/>
						<Schedule class="dashboard-item" />
					</div>
				</v-row>
				<v-row class="ma-0">
					<v-col v-if="widgets.jobsyoumanage.visible || widgets.mytasks.visible || widgets.leavesummary.visible || widgets.myexpenseclaims.visible || widgets.expenseclaims.visible" :cols="widgets.leaderboard.visible || widgets.timesheetsummary.visible ? 6 : 12" class="pt-0">
						<div v-if="widgets.leavesummary.visible" class="my-5">
							<DashboardItem
								:title="widgets.leavesummary.title"
								@dashboardItemClose="onDashboardItemClose(widgets.leavesummary)"
							/>
							<LeaveSummary class="dashboard-item" />				
						</div>
						<div v-if="widgets.myexpenseclaims && widgets.myexpenseclaims.visible" class="my-5">
							<DashboardItem
								:title="widgets.myexpenseclaims.title"
								@dashboardItemClose="onDashboardItemClose(widgets.myexpenseclaims)"
							/>
							<MyExpensesClaim class="dashboard-item" />
						</div>
						<div v-if="widgets.expenseclaims && widgets.expenseclaims.visible" class="my-5">
							<DashboardItem
								:title="widgets.expenseclaims.title"
								@dashboardItemClose="onDashboardItemClose(widgets.expenseclaims)"
							/>
							<ExpensesClaim class="dashboard-item" />				
						</div>
					</v-col>
					<v-col v-if="widgets.leaderboard.visible || widgets.timesheetsummary.visible"  :cols="widgets.jobsyoumanage.visible || widgets.mytasks.visible || widgets.leavesummary.visible || widgets.myexpenseclaims.visible || widgets.expenseclaims.visible ? 6 : 12" class="pt-0">
						<div v-if="widgets.leaderboard.visible" class="my-5">
							<DashboardItem
								:title="widgets.leaderboard.title"
								@dashboardItemClose="onDashboardItemClose(widgets.leaderboard)"
							/>
							<Leaderboard class="dashboard-item dashboard-item-special" />
						</div>
						<div v-if="widgets.timesheetsummary.visible" class="my-5">
							<DashboardItem
								:title="widgets.timesheetsummary.title"
								@dashboardItemClose="onDashboardItemClose(widgets.timesheetsummary)"
							/>
							<TimesheetSummary class="dashboard-item" />
						</div>
					</v-col>
				</v-row>
			</v-row>
			<div class="dashboard-container-xs" v-if="$vuetify.breakpoint.name === 'xs' && widgets && !loading">
				<div class="mt-4" v-if="widgets.jobsyoumanage.visible">
					<DashboardItem
						:title="widgets.jobsyoumanage.title"
						@dashboardItemClose="onDashboardItemClose(widgets.jobsyoumanage)"
					/>
					<JobsYouManage class="dashboard-item dashboard-item-special" @add-timesheet="onAddTimesheet"/>
				</div>
				<div class="mt-4" v-if="widgets.mytasks.visible">
					<DashboardItem
						:title="widgets.mytasks.title"
						@dashboardItemClose="onDashboardItemClose(widgets.mytasks)"
					/>
					<Schedule class="dashboard-item" />
				</div>
				<div class="mt-4" v-if="widgets.leaderboard.visible">
					<DashboardItem
						:title="widgets.leaderboard.title"
						@dashboardItemClose="onDashboardItemClose(widgets.leaderboard)"
					/>
					<Leaderboard class="dashboard-item dashboard-item-special" />
				</div>
				<div class="mt-4" v-if="widgets.leavesummary.visible">
					<DashboardItem
						:title="widgets.leavesummary.title"
						@dashboardItemClose="onDashboardItemClose(widgets.leavesummary)"
					/>
					<LeaveSummary class="dashboard-item" />				
				</div>
				<div class="mt-4" v-if="widgets.myexpenseclaims && widgets.myexpenseclaims.visible">
					<DashboardItem
						:title="widgets.myexpenseclaims.title"
						@dashboardItemClose="onDashboardItemClose(widgets.myexpenseclaims)"
					/>
					<MyExpensesClaim class="dashboard-item" />
				</div>
				<div class="mt-4" v-if="widgets.expenseclaims.visible">
					<DashboardItem
						:title="widgets.expenseclaims.title"
						@dashboardItemClose="onDashboardItemClose(widgets.expenseclaims)"
					/>
					<ExpensesClaim class="dashboard-item" />
				</div>
				<div class="mt-4" v-if="widgets.timesheetsummary.visible">
					<DashboardItem
						:title="widgets.timesheetsummary.title"
						@dashboardItemClose="onDashboardItemClose(widgets.timesheetsummary)"
					/>
					<TimesheetSummary class="dashboard-item" />
				</div>
			</div>
			<v-overlay :value="show_edit" class="overlay">
				<DashboardEdit @editClose="onEditClose" :items="widgets" />
			</v-overlay>
		</template>
		<v-dialog
			v-if="show_timesheet" 
			v-model="show_timesheet" 
			persistent
			:max-width="$vuetify.breakpoint.width <= 1024 ? maxWidth_xs: maxWidth"
		>
			<NewTimesheet :isAddTimesheet="true" :job="job_param" @cancel-timesheet="onCancelTimesheet"/>
		</v-dialog>
	</div>
</template>

<script>
import DashboardItem from '@/views/dashboard/DashboardItem';
import DashboardEdit from '@/views/dashboard/DashboardEdit';
import NewTimesheet from '@/views/timesheets/new_timesheet';
import ProgressDoubleLinear from '@/components/progress/progress_double_linear';
import JobsYouManage from '@/views/dashboard/jobsyoumanage';
import Leaderboard from '@/views/dashboard/leaderboard';
import Schedule from '@/views/dashboard/schedule';
import LeaveSummary from '@/views/dashboard/leave_summary';
import TimesheetSummary from '@/views/dashboard/timesheet_summary';
import MyExpensesClaim from '@/views/dashboard/my_expenses_claim';
import ExpensesClaim from '@/views/dashboard/expenses_claim';



// no longer used, either figure out if we want to bring them back or remove them
// import Placeholder from "@/components/home/placeholder";
// import Dashboard from "@/components/home/dashboard";
// import Jobs from "@/components/home/jobs";
// import Addressbook from "@/components/home/addressbook";
// import AdminVSBillable from '@/components/home/admin_vs_billable';
// import Period from '@/components/home/period';

/**
const available_tiles = [
	{
		name: 'my_tasks',
		path: '/tasks/tasklists',
		title: 'My tasks',
		privilege: '',
		default_visibility: true,
		max_width: 450,
		component: Tasks,
	},
	{
		name: 'leaderboard',
		path: '/',
		title: 'Leaderboard',
		privilege: '',
		default_visibility: true,
		max_width: 450,
		component: Leaderboard,
	},
	{
		name: 'jobsyoumanage',
		path: '/',
		title: 'Jobs you manage',
		privilege: 'J',
		default_visibility: true,
		max_width: 900,
		component: JobsYouManage,
	},
	{
		name: 'current_period',
		path: '/',
		title: 'Period',
		privilege: 'Ph',
		default_visibility: true,
		max_width: 450,
		component: Period,
	},
	{
		name: 'admin_vs_billable',
		path: '/',
		title: 'Admin v.s. billable',
		privilege: 'TsU,EPR', // either TsU or EPR
		default_visibility: false,
		max_width: 450,
		component: AdminVSBillable,
	},

	// !BAS! disable until we implement them..
	// 			{
	// 				name: "jobs",
	// 				path: '/jobs/search',
	// 				title: 'Jobs',
	// 				privilege: 'J',
	// 				default_visibility: true,
	// 				max_width: 450,
	// 				component: Jobs
	// 			},
	// 			{
	// 				name: "addressbook",
	// 				path: '/addressbook/search',
	// 				title: 'Address book',
	// 				privilege: 'AB',
	// 				default_visibility: true,
	// 				max_width: 450,
	// 				component: Addressbook
	// 			},
	// 			{
	// 				name: "placeholder",
	// 				path: '/',
	// 				title: 'Placeholder',
	// 				icon: null,
	// 				privilege: '',
	// 				default_visibility: false,
	// 				max_width: 450,
	// 				component: Placeholder
	// 			},
]; */

const Dashboard_Items = {
	leaderboard: {
		name: 'leaderboard',
		title: 'Leaderboard',
		privilege: '',
		visible: false,
		disabled: true
	},
	jobsyoumanage: {
		name: 'jobsyoumanage',
		title: 'Jobs I Manage',
		privilege: 'J',
		visible: false,
		disabled: true
	},
	mytasks: {
		name: 'mytasks',
		title: 'My Priorities',
		privilege: '',
		visible: false,
		disabled: true
	},
	leavesummary: {
		name: 'leavesummary',
		title: 'Annual Leave',
		privilege: '',
		visible: false,
		disabled: true
	},
	timesheetsummary: {
		name: 'timesheetsummary',
		title: 'Timesheet Summary',
		privilege: '',
		visible: false,
		disabled: true
	},
	myexpenseclaims: {
		name: 'myexpenseclaims',
		title: 'My Expense Claims',
		privilege: "Sev",
		visible: false,
		disabled: true
	},
	expenseclaims: {
		name: 'expenseclaims',
		title: 'Expense Claims',
		privilege: "Secap,Secapa",
		visible: false,
		disabled: true
	},
};

// Approve expense claim privilege
const AECP = 'Secap';

// Edit expense claim privilege
const EECP = 'Secapa';

export default {
	name: 'Dashboard',
	data() {
		this.maxWidth = 680;
		this.maxWidth_xs = '100%';

		return {
			loading: false,
			privileges: [],
			webclaim_postseperately: true,

			widgets_visible: [],
			widgets: null,

			show_edit: false,
			show_timesheet: false,
			job_param: null,
		}
	},
	components: {
		DashboardItem,
		DashboardEdit,
		JobsYouManage,
		Leaderboard,
		Schedule,
		LeaveSummary,
		TimesheetSummary,
		NewTimesheet,
		MyExpensesClaim,
		ExpensesClaim,
		ProgressDoubleLinear
	},
	async created() {
		await this.load_privileges();
		await this.load_postseperately();
		await this.load_widgets();

		this.init_widgets();

		// add this page to our breadcrumbs
		this.$store.commit('push_breadcrumb', {
			exact: true,
			text: 'Dashboard',
			to: this.$route.path,
		});
	},
	methods: {
		async load_privileges() {
			this.loading = true;
			const url = "/api/user/me/privileges";

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}					
				})
				.then(val => {
					let json = val.data;
					const { status, data, reason } = json;

					if (status == "OK") {
						this.privileges = data;
					} else {
						console.log('error-reason:', reason);
					}
				})
				.catch((e) => {
					console.log(e.message);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async load_postseperately() {
			this.loading = true;
			const url = "/api/expenses/claims/meta";

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.webclaim_postseperately = data.webclaim_postseperately === 0 ? false: true;
					} else {
						console.log('error-reason:', reason);
					}
				})
				.catch(e => {
					console.log('e.message:', e.message);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async load_widgets() {
			this.loading = true;
			const url = '/api/dashboard/widgets';

			await axios
				.get(url, {
					headers: {
						Authorization: 'Bearer ' + this.$store.state.token,
						Accept: 'application/json',
					},
				})
				.then((d) => {
					let json = d.data;

					const { status, data, reason } = json;

					if (status == 'OK') {
						const widgets_unique = [];
						const widgets_visible_arr = data.filter(d => { return d.visible });
						widgets_visible_arr.forEach(w => {
							if (!widgets_unique.includes(w.name)) {
								widgets_unique.push(w.name)
							}
						});
						this.widgets_visible = widgets_unique;
					} else {
						console.log('error-reason:', reason);
					}
				})
				.catch((e) => {
					console.log(e.message);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		init_widgets() {
			this.loading = true;
			const items_tmp = JSON.parse(JSON.stringify(Dashboard_Items));
			if (this.widgets_visible.length === 0) {
				for (const [item_key, item_value] of Object.entries(items_tmp)) {
					if (this._has_privilege(item_value.privilege)) {
						if (item_key === 'expenseclaims') {
							if (this.privileges.includes(AECP) && !this.privileges.includes(EECP) && !this.webclaim_postseperately) {
								item_value.visible = false;
								item_value.disabled = true;
							} else {
								item_value.visible = true;
								item_value.disabled = false;
							}
						} else {
							item_value.visible = true;
							item_value.disabled = false;
						}
					} else {
						item_value.visible = false;
						item_value.disabled = true;
					}
				}
			} else {
				// set disable and visible
				for (const [item_key, item_value] of Object.entries(items_tmp)) {
					if (this._has_privilege(item_value.privilege)) {
						if (item_key === 'expenseclaims') {
							if (this.widgets_visible.includes(item_key)) {
								if (this.privileges.includes(AECP) && !this.privileges.includes(EECP) && !this.webclaim_postseperately) {
									item_value.visible = false;
									item_value.disabled = true;
								} else {
									item_value.visible = true;
									item_value.disabled = false;
								}
							} else {
								item_value.visible = false;
								item_value.disabled = false;
							}
						} else {
							if (this.widgets_visible.includes(item_key)) {
								item_value.visible = true;
								item_value.disabled = false;
							} else {
								item_value.visible = false;
								item_value.disabled = false;
							}
						}
					} else {
						item_value.visible = false;
						item_value.disabled = true;
					}
				}
			}
			
			this.widgets = items_tmp;
			this.loading = false;
		},
		onDashboardItemClose(itemName) {
			if (itemName.visible) {
				itemName.visible = !itemName.visible;
			}
			this.setVisible();			
		},
		onEditClose() {
			this.show_edit = !this.show_edit;
			this.setVisible();			
		},
		setVisible() {
			const visible_name_list = [];
			for (const [key, value] of Object.entries(this.widgets)) {
				if (value['disabled'] === false) {
					const obj = {};
					if (value['visible'] === true) {
						obj[`${key}`] = true;
						visible_name_list.push(obj);
					} else {
						obj[`${key}`] = false;
						visible_name_list.push(obj);
					}
				}
			}

			for (let index = 0; index < visible_name_list.length; index++) {
				const element = visible_name_list[index];
				const name_arr = Object.keys(element);
				const visible_arr = Object.values(element);
				this._set_visible(name_arr[0], visible_arr[0]);
			}
		},
		onAddTimesheet(job_param) {
			job_param['id'] = job_param.job_id;
			this.job_param = job_param;

			this.show_timesheet = true;			
		},
		onCancelTimesheet() {
			this.show_timesheet = false;
			this.job_param = null;
		},
		_set_visible(name, isVisible) {
			const param_obj = {};
			param_obj['visible'] = isVisible ? 'Yes':'No';

			const url = `/api/dashboard/widgets/${name}`;

			axios
				.post(url, param_obj, {
					headers: {
						Authorization: 'Bearer ' + this.$store.state.token,
						Accept: 'application/json',
					},
				})
				.then((val) => {
					let json = val.data;

					if (json.status != 'OK') {
						console.log(json.reason);
					}
				})
				.catch((e) => {
					console.log(e.message);
				});
		},
		_has_privilege(privilege) {
			let access = false;

			if (privilege.length === 0) {
				access = true;
			} else {
				const privileges = privilege.split(",");
				privileges.forEach(priv => {
					if (this.privileges.includes(priv)) {
						access = true;
					}
				});
			}

			return access;
		},
		update_masonry() {
			let self = this;
			self.$nextTick(() => {
				self.$redrawVueMasonry('masonry_container');
			});
		},
	},
};
</script>

<style lang="scss" scoped>
#home {
  padding: 12px 0 24px 0;
  min-width: 100%;
  min-height: 100%;
}
.top-button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
	align-content: center;
  height: 36px;
  color: #192a3e;
  font-size: 14px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;

  .top-button-edit {
    width: 140px;
    border-radius: 4px;
    background: #ffffff;
		padding: 8px 12px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
		align-content: center;
    &:hover {
      cursor: pointer;
    }
  }
}
.dashboard-container-xs {
	display: flex;
	flex-flow: column nowrap;
}

.dashboard-item {
  background: #ffffff;
	padding: 12px;
	border-radius: 0 0 4px 4px;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	color: #192A3E;
	div {
		margin: 5px 0;
	}
}
.dashboard-item-special {
  height: 240px;
}

.overlay {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: flex-end;
}
</style>
